import { render, staticRenderFns } from "./SignaturePadReport.vue?vue&type=template&id=27ef645c&scoped=true"
import script from "./SignaturePadReport.vue?vue&type=script&lang=js"
export * from "./SignaturePadReport.vue?vue&type=script&lang=js"
import style0 from "./SignaturePadReport.vue?vue&type=style&index=0&id=27ef645c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ef645c",
  null
  
)

export default component.exports